import { apiRequest } from "./apiClient";
import type { BusinessUnitOption } from "../types/businessUnit";

type BusinessUnitsResponse = {
  readonly success: boolean;
  readonly data: readonly BusinessUnitOption[];
  readonly message: string;
};

export const fetchBusinessUnits = async (): Promise<readonly BusinessUnitOption[]> => {
  const response = await apiRequest("/business-units");
  const json = (await response.json()) as BusinessUnitsResponse;
  return Array.isArray(json.data) ? json.data : [];
};
